<template>
  <el-dialog :visible.sync="iframeVisible" width="60%" title="查看进度">
    <iframe width="100%" height="400px" :src="iframeSrc"> </iframe>
    <span slot="footer">
      <el-button class="btn-red" @click="iframeVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      iframeVisible: false,
      iframeSrc: "",
    }
  },
  computed: {},
  methods: {
    openDialog(instanceKey) {
      const inUse = ['prod', 'test', 'dev'].includes(process.env.VUE_APP_ENV)
      if (!inUse) {
        return this.$notify({
          title: '提示',
          message: '暂未开放，敬请期待',
          type: 'warning',
        })
      }
      const urlMap = {
        dev: 'https://mobiletestbpm.ab-inbev.cn',
        test: 'https://mobiletestbpm.ab-inbev.cn',
        prod: 'https://mprocesscenter.ab-inbev.cn'
      }

      let url = urlMap[process.env.VUE_APP_ENV]
      if (!url) {
        return
      }
      const targetUri = `/CTPServer/Flowchar/NewFlowcharListViewCKSH_CTP.aspx?ProcessName=销售项采购申请&IncidentNo=${instanceKey}`
      this.iframeSrc = url + targetUri
      console.log(this.iframeSrc)
      this.iframeVisible = true
    },
  },
}
</script>
<style lang="scss"></style>
